import _baseX from "base-x";
var exports = {};
var basex = _baseX;
var ALPHABET = "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz";
exports = basex(ALPHABET);
export default exports;